export default "__VITE_ASSET__CEyX5MJB__"